<template>
  <teleport to="#app">
    <div ref="modal" class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false">
      <form
        ref="form" class="modal-dialog"
        :class="[size, {'modal-dialog-centered': centered, 'modal-dialog-scrollable': scrollable}]"
        @submit.prevent
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <slot name="title" />
            </h5>
            <button v-if="closable" type="button" class="btn-close" @click="hide" />
          </div>
          <div class="modal-body">
            <slot name="body" />
          </div>
          <div class="modal-footer">
            <slot name="footer" />
          </div>
        </div>
      </form>
    </div>
  </teleport>
</template>

<script>
import modal from '@/modules/core/mixins/modal';

export default {
  mixins: [modal],
  expose: ['validate', 'show', 'hide'],
  methods: {
    validate() { return this.$refs.form.checkValidity(); },
    show() { this.show_(); },
    hide() { this.hide_(); },
  },
};
</script>
